import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [];

  connect() {
    console.log('Hello payment_methods');
    const selectedRadio = this.element.querySelector("input[name='booking[payment_method]']:checked");
    if (selectedRadio) {
      this.updateFormAction(selectedRadio.value);
    }
  }

  payments_switch(event) {
    this.updateFormAction(event.target.value);
  }

  updateFormAction(selected) {
    const form = this.element;
    // find Rails' hidden _method input
    const methodField = form.querySelector("input[name='_method']");

    if (selected === "jazzcash_bnpl") {
      form.action = form.dataset.bnplUrl;
      form.method = "get";
      form.removeAttribute("data-remote");
      if (methodField) methodField.value = "get";
    } else if (selected === "card_payment_jc") {
      form.action = form.dataset.cardUrl;
      form.method = "get";
      form.removeAttribute("data-remote");
      if (methodField) methodField.value = "get";
    } else {
      // For regular Jazzcash payment flow
      form.action = form.dataset.defaultUrl;
      form.method = "post";
      // Enable remote (Rails UJS)
      form.setAttribute("data-remote", "true");
      if (methodField) methodField.value = "patch";
    }
  }
}
